import register from 'ShopUiBundle/modules/app/registry';
import './fullscreen-video-teaser.scss';

// tslint:disable-next-line
register('fullscreen-video-teaser', () => import(/* webpackMode: "lazy" */'./fullscreen-video-teaser'));
